/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const HomeHealthNoAdmitReason = {
    ClinicallyInappropriate: 'clinically_inappropriate',
    InsurancePayerIssue: 'insurance_payer_issue',
    OutOfServiceArea: 'out_of_service_area',
    UnableToStaffTimely: 'unable_to_staff_timely',
    UnableToContactPatient: 'unable_to_contact_patient',
    PatientFamilyDeclined: 'patient_family_declined',
    ChoseAnotherAgency: 'chose_another_agency',
    ReadmittedHigherLevelOfCare: 'readmitted_higher_level_of_care',
    ReferralCancelledByProvider: 'referral_cancelled_by_provider',
    Deceased: 'deceased',
    Other: 'other',
} as const;
export type HomeHealthNoAdmitReason = typeof HomeHealthNoAdmitReason[keyof typeof HomeHealthNoAdmitReason];


export function instanceOfHomeHealthNoAdmitReason(value: any): boolean {
    for (const key in HomeHealthNoAdmitReason) {
        if (Object.prototype.hasOwnProperty.call(HomeHealthNoAdmitReason, key)) {
            if (HomeHealthNoAdmitReason[key as keyof typeof HomeHealthNoAdmitReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function HomeHealthNoAdmitReasonFromJSON(json: any): HomeHealthNoAdmitReason {
    return HomeHealthNoAdmitReasonFromJSONTyped(json, false);
}

export function HomeHealthNoAdmitReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthNoAdmitReason {
    return json as HomeHealthNoAdmitReason;
}

export function HomeHealthNoAdmitReasonToJSON(value?: HomeHealthNoAdmitReason | null): any {
    return value as any;
}

export function HomeHealthNoAdmitReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): HomeHealthNoAdmitReason {
    return value as HomeHealthNoAdmitReason;
}

